 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "assets/js/" + ({"DIMDDetail":"DIMDDetail","EditPassword":"EditPassword","ForgetPassword":"ForgetPassword","GCTDetail":"GCTDetail","Login":"Login","ctc":"ctc","footerAbout":"footerAbout","footerAddress":"footerAddress","footerAgreement":"footerAgreement","footerDownload":"footerDownload","footerPrivacy":"footerPrivacy","mall":"mall","mallDetail~partnerProgram~user~wallet":"mallDetail~partnerProgram~user~wallet","mallDetail~user~wallet":"mallDetail~user~wallet","mallDetail":"mallDetail","user~wallet":"user~wallet","mallOldDetail~user":"mallOldDetail~user","user":"user","wallet":"wallet","partnerProgram":"partnerProgram","mallOldDetail":"mallOldDetail","market":"market","news":"news","newsDetail":"newsDetail","question":"question","register":"register","sellOrderDetails":"sellOrderDetails"}[chunkId]||chunkId) + "." + {"DIMDDetail":"175e6bc6","EditPassword":"ca512087","ForgetPassword":"b057efe1","GCTDetail":"d77337b6","Login":"1f09844b","ctc":"a59f25a0","footerAbout":"c1e48d5b","footerAddress":"9b41a764","footerAgreement":"26c3d2e8","footerDownload":"c8689bec","footerPrivacy":"11438c4f","mall":"1a949a55","mallDetail~partnerProgram~user~wallet":"511cc370","mallDetail~user~wallet":"9a15bb82","mallDetail":"9ba0c61d","user~wallet":"30143ea4","mallOldDetail~user":"b2fcbdd8","user":"2245b830","wallet":"4e89c209","partnerProgram":"e7324b61","mallOldDetail":"abc23ca4","market":"6c5f60b6","news":"6e43c4d9","newsDetail":"dd539406","question":"5e9411bd","register":"be5918f1","sellOrderDetails":"5d221d73"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"DIMDDetail":1,"EditPassword":1,"ForgetPassword":1,"GCTDetail":1,"Login":1,"ctc":1,"footerAbout":1,"footerAddress":1,"footerAgreement":1,"footerDownload":1,"footerPrivacy":1,"mall":1,"mallDetail~user~wallet":1,"mallDetail":1,"user~wallet":1,"user":1,"wallet":1,"partnerProgram":1,"mallOldDetail":1,"market":1,"news":1,"newsDetail":1,"question":1,"register":1,"sellOrderDetails":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "assets/css/" + ({"DIMDDetail":"DIMDDetail","EditPassword":"EditPassword","ForgetPassword":"ForgetPassword","GCTDetail":"GCTDetail","Login":"Login","ctc":"ctc","footerAbout":"footerAbout","footerAddress":"footerAddress","footerAgreement":"footerAgreement","footerDownload":"footerDownload","footerPrivacy":"footerPrivacy","mall":"mall","mallDetail~partnerProgram~user~wallet":"mallDetail~partnerProgram~user~wallet","mallDetail~user~wallet":"mallDetail~user~wallet","mallDetail":"mallDetail","user~wallet":"user~wallet","mallOldDetail~user":"mallOldDetail~user","user":"user","wallet":"wallet","partnerProgram":"partnerProgram","mallOldDetail":"mallOldDetail","market":"market","news":"news","newsDetail":"newsDetail","question":"question","register":"register","sellOrderDetails":"sellOrderDetails"}[chunkId]||chunkId) + "." + {"DIMDDetail":"7bca8bc7","EditPassword":"bafc0f11","ForgetPassword":"75058ec9","GCTDetail":"097be301","Login":"a4dd0048","ctc":"8e25e530","footerAbout":"42ff9d4b","footerAddress":"45211875","footerAgreement":"c63be2e3","footerDownload":"8c6235f3","footerPrivacy":"e3a6a39a","mall":"d208e725","mallDetail~partnerProgram~user~wallet":"31d6cfe0","mallDetail~user~wallet":"0683764b","mallDetail":"fb139e90","user~wallet":"cba46f3d","mallOldDetail~user":"31d6cfe0","user":"2aaa6ac8","wallet":"328fc7b7","partnerProgram":"6466b3bb","mallOldDetail":"a8d40939","market":"74d27c91","news":"0a2b7a4c","newsDetail":"f60fdcd2","question":"67c3804a","register":"232f5a44","sellOrderDetails":"4b7c8322"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
